/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import { edit_inside_object } from "../../App/actions/biActions";

/*PICTURE*/

/*FUNCTION*/
import { ErrorContext } from "../../Debug/ErrorHandler/ErrorContext";

/*DATA*/
import basemap_styles from "../../App/validation/basemap_styles";
import dict from "../../Data/dict.json";

/*CONST*/

class BI_EDIT_BASEMAP extends Component {
  state = {};

  static contextType = ErrorContext;

  on_change_basemap = (value) => {
    const { handleError } = this.context;

    handleError(() => {
      this.props.edit_inside_object({
        key: "setting_add_object",
        id_key: "basemap_mode",
        value: value,
      });
    })();
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state

    //global props
    const { setting_add_object } = this.props.bi;

    //content
    const basemap_mode = setting_add_object?.basemap_mode;

    return (
      <main>
        <h1 className="text_bold margin_bottom">
          {dict?.["Set basemap"]?.[language]}
        </h1>
        {basemap_styles()?.map((item, idx) => {
          return (
            <button
              key={idx}
              className={`button outline_black margin_bottom margin_right ${
                basemap_mode === item?.value
                  ? "background_black"
                  : "background_white"
              }`}
              onClick={this.on_change_basemap.bind(this, item.value)}
              data-mapid={`selectBaseMap-${idx}`}
            >
              {item?.name}
            </button>
          );
        })}
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  bi: state.bi,
  project: state.project,
});

export default connect(mapStateToProps, { edit_inside_object })(
  BI_EDIT_BASEMAP
);
